var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFenetreB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_1474)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M238.102 120.051V162.845C202.454 183.416 159.884 211.593 124.236 232.176V183.236C160.03 167.137 202.307 136.173 238.102 120.051Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9202 116.613C31.5589 106.434 50.209 96.2553 68.8477 86.0653C93.9017 122.275 112.316 147.363 137.37 183.562C174.917 162.148 212.453 140.723 250 119.309C225.35 85.481 200.701 51.6526 176.052 17.8242C140.201 32.9127 104.361 48.0013 68.5107 63.0898C49.9842 80.9309 31.4466 98.772 12.9202 116.613Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.583 115.849L124.449 183.562L68.5106 85.3013L12.5718 115.849H12.583Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.583 115.849L124.449 183.562L66.0052 80.8297L12.583 115.838V115.849Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 108.883C4.19063 111.209 8.3925 113.535 12.5831 115.849L66.1289 81.3354L124.449 183.573H137.448L68.5219 63.0898C45.6813 78.3581 22.8406 93.6152 0 108.883Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.583 115.849L124.461 183.573L124.213 232.176L13.5492 158.328L12.583 115.849Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.011 96.2882C122.102 91.1921 133.181 86.096 144.272 81L144.351 81.1243C151.126 91.3051 159.237 105.147 166 115.328C154.445 121.362 143.705 126.966 132.15 133C125.104 120.763 118.058 108.525 111 96.2882H111.011Z",
    fill: "#FEE4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.347 81.1243L144.267 81C133.175 86.0972 122.093 91.1943 111 96.2915C112.167 98.3145 113.334 100.338 114.501 102.361C123.793 98.0207 133.084 93.692 142.364 89.3521C147.315 97.2747 152.278 105.209 157.23 113.131C147.825 117.935 138.421 122.738 129.005 127.541C130.047 129.361 131.101 131.18 132.143 133C143.701 126.965 154.443 121.359 166 115.324L144.347 81.1131V81.1243Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 75.1086C166.276 70.4057 176.562 65.7028 186.838 61L186.916 61.1215C193.199 70.5161 200.728 83.2889 207 92.6946C196.291 98.2585 186.326 103.436 175.606 109C169.067 97.7065 162.528 86.4131 156 75.1196V75.1086Z",
    fill: "#FEE4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.916 61.1214L186.838 61C176.562 65.7039 166.276 70.4078 156 75.1118C157.079 76.9779 158.157 78.844 159.247 80.7101C167.855 76.7129 176.473 72.7046 185.081 68.7074C189.674 76.0283 194.267 83.3382 198.86 90.6591C190.141 95.098 181.411 99.5259 172.692 103.965C173.66 105.643 174.638 107.322 175.606 109C186.315 103.435 196.28 98.256 207 92.6908L186.916 61.1104V61.1214Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 76.0201C165.005 83.3467 174.01 90.6734 183.026 98C193.688 92.5078 204.338 87.0156 215 81.5235C205.862 75.349 196.723 69.1745 187.585 63C177.056 67.34 166.528 71.6801 156.011 76.0201H156Z",
    fill: "#FECECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_1474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenetreB);
export default __webpack_public_path__ + "static/media/fenetreB.b276b949fa9cf7242c85399fab01217e.svg";
export { ForwardRef as ReactComponent };